import { defineEntity, custom } from './_helpers.js';

export default defineEntity('vendorAssessment', {
    reviewReminder: custom({ scope: 'state' }),
});
